// extracted by mini-css-extract-plugin
module.exports = {"menuToggler":"MenuToggler_menuToggler__ObNTa","menuToggler--open":"MenuToggler_menuToggler--open__Fo3ex"};